export default __webpack_public_path__ + "static/tagline-7df71deff5ce4584ab3a3e3cc31c74e2.png";